import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DynamicWidthPropertyLabel = ({
  label
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "span",
    textWrap: "nowrap",
    color: "text-core-subtle",
    display: "block",
    children: /*#__PURE__*/_jsxs(Flex, {
      as: "span",
      children: [/*#__PURE__*/_jsx(TruncateString, {
        useFlex: true,
        children: label
      }), /*#__PURE__*/_jsx(_Fragment, {
        children: ":\xA0"
      })]
    })
  });
};
export default DynamicWidthPropertyLabel;